import { DataService } from './dataService'

const BlogService = {
	getBlog: async (data) => {
		return DataService.get('/admin/blog_list', data)
	},
	deleteBlog: async (data) => {
        return DataService.delete('/admin/delete_blog?id=' + data.id, data)
    },
    addBlog: async (data) => {
		return DataService.post('/admin/add_blog', data)
	},
    editBlog: async (data) => {
		return DataService.update('/admin/update_blog', data)
	}
}

export default BlogService